export default "__VITE_ASSET__f35dfe51__"